export * from './effectifs.module';
export * from './effectifs-wrapper/effectifs-wrapper.component';

